import { render, staticRenderFns } from "./YearPage.vue?vue&type=template&id=37a4d375"
import script from "./YearPage.vue?vue&type=script&lang=js"
export * from "./YearPage.vue?vue&type=script&lang=js"
import style0 from "./YearPage.vue?vue&type=style&index=0&id=37a4d375&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports